import React, { useEffect, useState } from "react";
import "firebase/firestore";
import { currentDate } from "../../help/currentDate";
import MainDisplay from "./MainDisplay";
import calculateTripSum from "../../help/calculateTripSum";
import FirebaseConnection from "../../help/FirebaseConnection";

const MainContainer = () => {

  const skippers = ["Manfred", "Klaus", "Christian", "Flori", "*"];
  const [selSkipper, setSelSkipper] = useState("Manfred");
  const [date, setDate] = useState(currentDate);
  const [duration, setDuration] = useState("");
  const [comment, setComment] = useState("");
  const [list, setList] = useState([]);
  const [showList, setShowList] = useState(false);
  const [totalDuration, setTotalDuration] = useState(0);
  const [submit, setSubmit] = useState(0);
  const [yearFrom, setYearFrom ] = useState(currentDate().slice(-2))

  const fireBaseConnection = new FirebaseConnection();

  const handleSendToFirebase = async () => {
    await fireBaseConnection.writeData(selSkipper, date, duration, comment);
    setDuration("");
    setComment("");
    setSubmit(Math.random());
  };

  const handleShowLogs = () => {
    setShowList(!showList);
  };

  useEffect(() => {
    if (showList) {
      fireBaseConnection.readData(selSkipper, yearFrom).then((data) => {
        setList(data);
      });
    }
  }, [selSkipper, showList, submit]);

  useEffect(() => {
    const sum = calculateTripSum(list);
    setTotalDuration(sum);
  }, [list]);

  const handleDeleteLog = async (id) => {
    await fireBaseConnection.deleteData(id);
    setSubmit(Math.random());
  };

  return (
    <MainDisplay
      skippers={skippers}
      setSelSkipper={setSelSkipper}
      date={date}
      setDate={setDate}
      duration={duration}
      setDuration={setDuration}
      comment={comment}
      setComment={setComment}
      handleSendToFirebase={handleSendToFirebase}
      handleShowLogs={handleShowLogs}
      list={list}
      totalDuration={totalDuration}
      handleDeleteLog={handleDeleteLog}
      showList={showList}
      yearFrom={yearFrom}
      setYearFrom={setYearFrom}
    />
  );
};

export default MainContainer;
